import * as React from 'react';
export default () => (props) => {
    const value = props.value || {
        lat: 0,
        lng: 0,
    };
    const { lat, lng } = value;
    return (React.createElement("div", null,
        React.createElement("input", { value: value.lng, onChange: (e) => props.setValue({
                lat,
                lng: parseInt(e.target.value, 10) || 0,
            }) }),
        React.createElement("input", { value: value.lat, onChange: (e) => props.setValue({
                lng,
                lat: parseInt(e.target.value, 10) || 0,
            }) })));
};
